import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Importiere die Übersetzungsdateien
import translationEN from './locales/en/translation.json';
import translationDE from './locales/de/translation.json';
import translationPL from './locales/pl/translation.json';
import translationFR from './locales/fr/translation.json';
import translationTR from './locales/tr/translation.json';
import translationRU from './locales/ru/translation.json';
import translationAR from './locales/ar/translation.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    detection: {
      // zuerst im localStorage, dann vom Browser
      order: ['localStorage', 'navigator'],
      // Sprache im localStorage speichern
      caches: ['localStorage'],
    },
    resources: {
      en: { translation: translationEN },
      de: { translation: translationDE },
      pl: { translation: translationPL },
      fr: { translation: translationFR },
      tr: { translation: translationTR },
      ru: { translation: translationRU },
      ar: { translation: translationAR },
    },
    //lng: 'en', // Standardsprache, falls nichts gefunden wird
    supportedLngs: ['en', 'de', 'pl', 'fr', 'tr', 'ru', 'ar'],
    load: 'languageOnly', // Wandelt "de-DE" zu "de" um
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React übernimmt den XSS-Schutz
    },
  });

export default i18n;
